export default __webpack_public_path__ + "static/media/carousel-2.eb701816.jpg";